import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatTabs } from '@blocks-react/components/Tabs';

type CatTabProps = ComponentProps<typeof CatTabs>;
export const CustomerAccountTabs: FC<PropsWithChildren<CatTabProps>> = ({
  onBlTabChange,
  children,
  ...tabProps
}) => {
  return (
    <CatTabs onBlTabChange={onBlTabChange} {...tabProps}>
      {children}
    </CatTabs>
  );
};
